import WordArea from "./WordArea";
import Keyboard from "./Keyboard";
import FailedCard from "./FailedCard";
import generatePuzzle from './generatePuzzle';
import React from "react";

class GameArea extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      guesses: [],
      target: "",
      input: "",
      loading: false,
      loaded: false,
      ready: false,
      failed: false,
      down: false,
    }

    this.newPuzzle = {};
    this.correct = false;
    this.swapInPuzzle = this.swapInPuzzle.bind(this);
    this.clearInput = this.clearInput.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.giveUp = this.giveUp.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  componentDidMount() {
    document.onkeydown = this.handleInput.bind(this);
    this.loadPuzzle();
    this.swapInPuzzle();
    this.props.giveUp(this.giveUp);
    this.props.refresh(this.refresh);
    this.props.getWords(() => this.correct ? this.state.guesses.concat([this.state.target]) : this.state.guesses);
  }

  loadPuzzle() {
    this.setState({ loading: true });
    //fetch(`http://127.0.0.1:5000/generate_puzzle?max_green=${this.props.parameters.maxGreen}&max_yellow=${this.props.parameters.maxYellow}&word_length=${this.props.parameters.wordLength}`)
    //fetch(`https://george-plays-wordle-backend.herokuapp.com/generate_puzzle?max_green=${this.props.parameters.maxGreen}&max_yellow=${this.props.parameters.maxYellow}&word_length=${this.props.parameters.wordLength}`)
    let data = generatePuzzle(this.props.parameters.maxGreen, this.props.parameters.maxYellow, this.props.parameters.wordLength);
    if (data.error) {
      this.setState({ failed: true }, console.log(data.error))
    } else {
      this.newPuzzle = {
        guesses: data.guesses,
        target: data.target
      };
      this.setState({ loading: false, loaded: true });
      console.log(data.target)
    }
    //.catch(e => this.setState({ down: true }, console.log(e)));
  }

  swapInPuzzle() {
    this.setState({ready: false})
    if (!this.state.loaded) {
      window.setTimeout(this.swapInPuzzle, 50);
    } else {
      this.setState({
        guesses: this.newPuzzle.guesses,
        target: this.newPuzzle.target,
        loaded: false,
        ready: true
      })
      this.newPuzzle = {};
      this.loadPuzzle();
    }  
  }

  handleInput(e) {
    if (!this.correct) {
      if (e.which === 8) {  // Backspace
        this.setState({ input: this.state.input.slice(0, -1) });
      } else if (e.which === 13 || e.which === 32) {  // Return or space
        if (this.state.input === this.state.target) {
          this.correct = true;
          this.submit(true);
        } else {
          this.submit(false);
        }
      } else if (65 <= e.which && e.which <= 90 && this.state.input.length < this.state.target.length) {  // In range a-z
        this.setState({ input: this.state.input + e.key.toUpperCase() }, () => {
          if (this.state.input.length === this.state.target.length) {
            setTimeout(() => this.handleInput({ key: "ENTER", which: 13 }), 150);
          }
        });
      }
    }
  }

  clearInput() {
    this.correct = false;
    this.setState({
      input: ""
    })
  }

  giveUp() {
    this.correct = true;
    this.setState({input: this.state.target});
    this.submit(true);
  }

  refresh() {
    this.newPuzzle = {};
    this.correct = false;
    this.setState({
      guesses: [],
      target: "",
      input: "",
      loading: false,
      loaded: false,
      ready: false,
      failed: false,
    }, () => {
      this.loadPuzzle();
      this.swapInPuzzle();
    });
  }

  render() {
    var report = document.getElementsByClassName("report")[0];
    if (report) {
      if (this.state.ready && !this.state.failed && !this.state.down) {
        report.style.display = "flex";
      } else {
        report.style.display = "none";
      }
    }

    let contents;
    if (this.state.failed) {
      contents = <FailedCard message1={"Failed to fetch puzzle"} message2={"Requirements too restrictive"} />;
    } else if (this.state.down) {
      contents = <FailedCard message1={"Unfortunately George Plays Wordle is"} message2={"currently down for maintenance."} />;
    } else if (this.state.loading && !this.state.ready) {
      contents = (<div className="loader" />);
    } else {
      contents = (
        <React.Fragment>
          <WordArea
            guesses={this.state.guesses}
            target={this.state.target}
            input={this.state.input}
            swapInPuzzle={this.swapInPuzzle}
            clearInput={this.clearInput}
            submit={call => this.submit = call}
          />
          <Keyboard
            guesses={this.state.guesses}
            target={this.state.target}
            handleInput={this.handleInput}
          />
        </React.Fragment>
      );
    }
    return (
      <div className="game-area">
        {contents}
      </div>
    );
  }
}

export default GameArea;